import { render } from "./CoReg_Receipt.vue?vue&type=template&id=5ba6785c&scoped=true"
import script from "./CoReg_Receipt.vue?vue&type=script&lang=js"
export * from "./CoReg_Receipt.vue?vue&type=script&lang=js"

import "./CoReg_Receipt.vue?vue&type=style&index=0&id=5ba6785c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba6785c"]])

export default __exports__